import styled from "styled-components";

export const Contant = styled.div`
    height: 100%;
    
`
